import EditOffIcon from '@mui/icons-material/EditOff'
import { orderApiSpace } from 'feature/productOrder/namespaces/orderApiSpace'
import { ModalConfirm } from 'feature/user/components'
import { useState } from 'react'
import { useActions } from 'store/hooks'

import style from './ProductSelectParamsCard.module.scss'
import { PropsCardHeader } from './PropsCardHeader'
import { PropsCardInputType } from './PropsCardInputType'

type PropsCardProps = {
  data: orderApiSpace.ProductParam
}

// шаг 2
// выбор параметров для продукта
// -> карточка продукта (в ней список параметров)
export function ProductSelectParamsCard({ data }: PropsCardProps) {
  const { removeProductOrder } = useActions()
  const [isModalOpen, setModalOpen] = useState<boolean>(false)

  return (
    <div className={style.propsCard}>
      <PropsCardHeader
        title={data.productName}
        handleClose={() => {
          setModalOpen(true)
        }}
      />
      {data.parameters?.length ? (
        <div className={style.fieldsList}>
          {data.parameters.map(item => (
            <PropsCardInputType
              data={item}
              productId={data.productId}
              key={item.id}
            />
          ))}
        </div>
      ) : (
        <div className={style.outParams}>
          <EditOffIcon fontSize='inherit' className={style.editOffIcon} />
          <span>Уточнение параметров не требуется</span>
        </div>
      )}
      <ModalConfirm
        onConfirm={() => {
          removeProductOrder(data.productId)
        }}
        cancelText='Отмена'
        actionText='Да'
        modalText='Вы точно хотите удалить изделие?'
        isModalOpen={isModalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </div>
  )
}
